export default {
  "content": "<title>Group</title>",
  "attrs": {
    "width": "360",
    "height": "360",
    "viewBox": "0 0 360 360",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};